import { createSlice } from "@reduxjs/toolkit";

const devoteeFeedBackSlice = createSlice({
  name: "reviews",
  initialState: {
    isLoading: false,
    error: "",
    reviewList: [] as any[],
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setReviewList: (state, action) => {
      state.reviewList = action.payload;
    },
  },
});

export const { setLoading, setError, setReviewList } =
  devoteeFeedBackSlice.actions;
export default devoteeFeedBackSlice.reducer;
